// eslint-disable-next-line no-shadow
enum ColorLogo {
  LIGHT = 'light',
  DARK = 'dark',
}

export default ColorLogo;
